import SnapshotsAdapter from './base';

export default class Snapshot extends SnapshotsAdapter {
  modelNamePlural = 'snapshots';
}
